import ReactDOM from 'react-dom';
import { Typography } from '@saesa/ui-kit-front';
import { useTranslation } from 'react-i18next';
import { BottonContinuarProceso, BottonCancelarProceso } from './ModalButtons';

/**
 * Propiedades del componente BaseModal
 */
interface BaseModalProps {
  guardarCambios: () => void;
  cerrarModal: () => void;
  tipo: string;
  obtenerIconoModal: (tipo: string) => string;
  obtenerTituloModal: (tipo: string, t: any) => string;
  obtenerSubTituloModal: (tipo: string, t: any) => string;
  obtenerTextoBotonCancelar: (tipo: string, t: any) => string;
  obtenerTextoPrimerBoton: (tipo: string, t: any) => string;
  styles: any;
}

/**
 * Componente base modal
 * @param param0
 * @returns
 */
const BaseModal = ({
  guardarCambios,
  cerrarModal,
  tipo,
  obtenerIconoModal,
  obtenerTituloModal,
  obtenerSubTituloModal,
  obtenerTextoBotonCancelar,
  obtenerTextoPrimerBoton,
  styles,
}: BaseModalProps) => {
  /**
   * Selecciona el elemento modal
   */
  const element = document.getElementById('modal')!;

  /**
   * Componente de traduccion i18n
   */
  const { t } = useTranslation();

  return element
    ? ReactDOM.createPortal(
        <div className={styles.backdrop}>
          <section className={`${styles.modalGlobal} `}>
            <div className={`${styles.contenedorGlobal}`}>
              <img src={obtenerIconoModal(tipo)} alt="Guardar información" />
              <div className={`${styles.contenedorTextosGlobal}`}>
                <Typography className={styles.tituloTextos}>{obtenerTituloModal(tipo, t)}</Typography>
                <Typography className={styles.parrafoGlobal}>{obtenerSubTituloModal(tipo, t)}</Typography>
              </div>
            </div>
            <div className={styles.contenedorBotones}>
              <BottonCancelarProceso type="button" variant="contained" color="primary" onClick={cerrarModal} data-testid="cerrarModal">
                {obtenerTextoBotonCancelar(tipo, t)}
              </BottonCancelarProceso>

              <BottonContinuarProceso type="button" variant="contained" color="primary" onClick={guardarCambios} data-testid="botonAceptar">
                {obtenerTextoPrimerBoton(tipo, t)}
              </BottonContinuarProceso>
            </div>
          </section>
        </div>,
        element
      )
    : null;
};

export default BaseModal;
